module.exports = __webpack_public_path__ + "img/fopeaInsultosX4.98e80b77.jpg";